import { styled } from '@material-ui/core';

export const StyledVideo = styled('video')({ maxWidth: '100%' });
